import { IterableDiffer, IterableDiffers, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'beeArrayChangeDetector',
  pure: false
})
export class BeeArrayChangeDetectorPipe implements PipeTransform {
  private differ: IterableDiffer<any>;

  constructor(iDiff: IterableDiffers) {
    this.differ = iDiff.find([]).create();
  }

  transform(value: any[]): any[] {
    if (this.differ.diff(value)) {
      return [...value];
    }

    return value;
  }
}
